import {
  Tabs, Typography
} from 'antd';
import React from 'react';
import HeaderWrapper from '../../../components/headerWrapper';
import PageWrapper from '../../../components/pageWrapper';
import CostConfig from './costConfig/CostConfig';
import OutlierConfig from './outlierConfig/OutlierConfig';
import PlantGroupConfig from './plantGroupConfig/PlantGroupConfig';
import WidgetViewSettings from './widgetSetting/WidgetViewSettings';


const { Title } = Typography;

const ConfigContainer = () => {
  const { TabPane } = Tabs;

  return (
    <PageWrapper>
      <HeaderWrapper>
        <Title level={3} style={{ color: 'var(--neutral--100)' }}>Admin Settings</Title>
      </HeaderWrapper>
      <Tabs defaultActiveKey="1">
        <TabPane tab="Cost configuration" key="1">
          <CostConfig />
        </TabPane>
        <TabPane tab="Outlier configuration" key="2">
          <OutlierConfig />
        </TabPane>
        <TabPane tab="Plant Groups" key="3">
          <PlantGroupConfig />
        </TabPane>
        <TabPane tab="Widget Views" key="4">
          <WidgetViewSettings />
        </TabPane>
      </Tabs>
    </PageWrapper>
  );
};

export default ConfigContainer;
